exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-area {\n  padding-bottom: 60px;\n}\n.content-row {\n  margin-right: 0;\n}\n.mobile-padding {\n  padding-right: 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/layout/styles.css
// module id = 2016
// module chunks = 29